import { render } from "./BarChartA.vue?vue&type=template&id=03584552&scoped=true"
import script from "./BarChartA.vue?vue&type=script&lang=ts"
export * from "./BarChartA.vue?vue&type=script&lang=ts"

import "./BarChartA.vue?vue&type=style&index=0&id=03584552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03584552"

export default script